export default __webpack_public_path__ + "static/media/butterfinger-image.bee31035.png";